import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import { decryptionAPI } from "../../utils/Encryption";
const API_URL = "http://localhost:5099/";
const UPLOAD_ENDPOINT = "api/Common/SaveFileToAmazon";

function TinyEceEditor({ handleChange, ...props }) {
  const custom_config = {
    extraPlugins: [uploadPlugin],
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "blockQuote",
        "insertTable",
        "|",
        // 'imageUpload',
        "undo",
        "redo",
      ],
    },
    table: {
      contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
    },
  };
  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append("file", file);
            body.append("filename", file.filename);

            var config = { headers: { "content-type": "multipart/form-data" } };

            axios
              .post(`${API_URL}/${UPLOAD_ENDPOINT}`, body, config)
              .then((response) => {
                response = decryptionAPI(response.data);
                resolve({
                  default: `${API_URL}/${response.filePath}`,
                });
              })
              .catch((error) => {
              });
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }
  return (
    <div className="tiny-editor-sec" key={props && props.key ? `${props.key}div` : "TinyMCESection"}>
      <Editor
        value={props.data}
        key={props && props.key ? props.key : "TinyMCE"}
        // config={custom_config}
        // onReady={(editor) => {}}
        // onBlur={(event, editor) => {}}
        // onFocus={(event, editor) => {}}
        // onChange={(event, editor) => {
          //   handleChange(editor.getData());
          // }}
          onEditorChange={(newText, editor) => props.onTinyEceEditorChange(newText, editor)}
          {...props}
          init={{
          menubar : props.isMenubarNotRequired && props.isMenubarNotRequired === true ? false : true,
          plugins: "link image code lists wordcount table",
          toolbar: props.isToolbarNotRequired && props.isToolbarNotRequired === true ? "" : "undo redo | bold italic | alignleft aligncenter alignright | code | bullist numlist checklist outdent indent | wordcount | table",
          statusbar: false,
          visual: false,
          // content_css: "index.css",
          selector: 'textarea',
          // powerpaste_allow_local_images: true,
          paste_as_text: true,
          content_style: ' body{font-family: Roboto, sans-serif !important; color:#848484;}#tinymce{color:#848484; border:none; } table tr th{padding:5px;}',
        }}
        apiKey="abgacn6b2jrusncpwzlgg311vrm7p5pey06jwehu1pkfbtej"
      />
    </div>
  );
}

export default TinyEceEditor;
